import { Zap, Target, Clock, ShieldOff } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Zap, title: "Extremely Fast Shortlisting", desc: "Go from a stack of resumes to a ranked shortlist in minutes, not days." },
  { icon: Target, title: "Consistent Scoring Precision", desc: "Every candidate is measured against the exact same weighted competency matrix." },
  { icon: Clock, title: "Saves Time & Manual Effort", desc: "No more manually reading every resume line by line to compare candidates." },
  { icon: ShieldOff, title: "No False Rejections", desc: "Evidence-based evaluation — unlike rigid keyword-matching ATS filters." },
];

export default function LandingHighlights() {
  return (
    <section className="border-y border-border/70 bg-muted/40 px-4 py-14 sm:px-6 lg:px-8" data-testid="landing-highlights">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {HIGHLIGHTS.map((h, idx) => (
          <div
            key={h.title}
            className="flex flex-col items-start gap-3 rounded-2xl border border-border/60 bg-card p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md animate-in fade-in-0 slide-in-from-bottom-2 duration-500 glossy-card glossy-sheen"
            style={{ animationDelay: `${idx * 90}ms` }}
            data-testid={`landing-highlight-${idx}`}
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/15">
              <h.icon className="h-5 w-5 text-primary" />
            </div>
            <div className="font-heading text-sm font-semibold sm:text-base">{h.title}</div>
            <p className="text-xs leading-relaxed text-muted-foreground sm:text-sm">{h.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
